// src/components/inbox/ClientSidebar.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader";
import { readCurrentUser } from "../../shared/_helpers/currentUser";
import { loadTab, selectClientTabs } from "../../redux/inboxSlice";
import SummaryTab from "./SummaryTab";
import DataTab from "./DataTab";
import DocumentsTab from "./DocumentsTab";
import LoadFailed from "./LoadFailed";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui";

const TABS = [
  { id: "summary", label: "Summary" },
  { id: "data", label: "Data" },
  { id: "documents", label: "Documents" },
];

// The client-record column: three tabs, each read from its endpoint the
// first time it is selected in this open of the client's thread and cached in
// inboxSlice.tabs (every tab read writes a ReadLog row server-side; opening
// the thread drops the cache, R89). A failed read is shown
// in the panel with Try again (R71).
export default function ClientSidebar({ clientId, client }) {
  const dispatch = useDispatch();
  const [tab, setTab] = useState("summary");
  const entry = useSelector(selectClientTabs(clientId));
  const viewerId = readCurrentUser()?.user?._id ?? null;

  useEffect(() => {
    dispatch(loadTab(clientId, tab));
  }, [clientId, tab, dispatch]);

  const status = entry?.status?.[tab] ?? "idle";
  const payload = status === "ready" ? entry[tab] : null;

  return (
    <aside
      data-slot="inbox-col--side"
      className="tw-flex tw-min-w-0 tw-w-80 tw-flex-none tw-flex-col tw-border-0 tw-border-l tw-border-solid tw-border-divider tw-bg-surface max-lg:tw-w-full max-lg:tw-border-l-0 max-lg:tw-border-t"
    >
      <Tabs
        value={tab}
        onValueChange={setTab}
        className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"
      >
        <TabsList className="tw-mb-0 tw-gap-0 tw-px-4">
          {TABS.map(({ id, label }) => (
            <TabsTrigger key={id} value={id} className="tw-flex-1">
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={tab} className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto">
        {status === "loading" && <Loader />}
        {status === "error" && (
          <LoadFailed
            message={entry?.errors?.[tab]}
            onRetry={() => dispatch(loadTab(clientId, tab, { retry: true }))}
          />
        )}
        {payload && tab === "summary" && (
          <SummaryTab
            clientId={clientId}
            summary={payload}
            viewerId={viewerId}
          />
        )}
        {payload && tab === "data" && (
          <DataTab clientId={clientId} data={payload} client={client} />
        )}
        {payload && tab === "documents" && (
          <DocumentsTab documents={payload} client={client} />
        )}
        </TabsContent>
      </Tabs>
    </aside>
  );
}
